// FormikSubmitButton.jsx
import React from "react";
import { useTheme } from "@mui/material/styles";
import { Button } from "@mui/material";
import { useFormikContext } from "formik";

export default function FormikSubmitButton({
  name,
  className = "",
  canSubmit,
}) {
  const theme = useTheme();
  const { isSubmitting } = useFormikContext();

  // Use canSubmit prop if provided, otherwise button is enabled by default
  const disabled =
    isSubmitting || (canSubmit !== undefined ? !canSubmit : false);

  return (
    <Button
      type="submit"
      variant="contained"
      className={className}
      disabled={disabled}
      sx={{
        backgroundColor: theme.palette.buttonHover.main,
        "&:hover": {
          backgroundColor: theme.palette.buttonHover.secondary,
        },
        color: theme.palette.white.main,
        textTransform: "none",
      }}
    >
      {isSubmitting ? "Loading..." : name}
    </Button>
  );
}
